var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecureFileDownloadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.08,
    height: 16,
    viewBox: "0 0 14.08 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-download-svgrepo-com",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M11.4,3a.88.88,0,0,1,.88.88v8.436L14.3,10.3a.88.88,0,1,1,1.244,1.244l-3.52,3.52a.88.88,0,0,1-1.244,0l-3.52-3.52A.88.88,0,1,1,8.5,10.3l2.018,2.018V3.88A.88.88,0,0,1,11.4,3Z",
    transform: "translate(-0.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M5.76,16.88a.88.88,0,0,0-1.76,0v.528A2.987,2.987,0,0,0,6.992,20.4h8.1a2.987,2.987,0,0,0,2.992-2.992V16.88a.88.88,0,1,0-1.76,0v.528a1.227,1.227,0,0,1-1.232,1.232h-8.1A1.227,1.227,0,0,1,5.76,17.408Z",
    transform: "translate(0 -1.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureFileDownloadIcon);
export default __webpack_public_path__ + "static/media/secure-file-download-icon.6d4d2bfbd4d120671047c3d8ea26ec8a.svg";
export { ForwardRef as ReactComponent };